import React, { useState } from 'react';
import { useNavigate } from 'react-router';

import styled from '@emotion/styled';

import Card from '../../../components/Cards/Card';
import BallIcon from '../../../components/Icons/BallIcon';
import CashIcon from '../../../components/Icons/CashIcon';
import LargeDotIcon from '../../../components/Icons/LargeDotIcon';
import ProfileListIcon from '../../../components/Icons/ProfileListIcon';
import StarIcon from '../../../components/Icons/StarIcon';
import { Modal } from '../../../components/Modal/Modal';
import TopTierBenchmarkModal from '../../../components/Modal/ModalActions/TopTierBenchmarkModal/TopTierBenchmarkModal';
import { useAppSelector } from '../../../redux/store';
import { REVENUE_PRICE_MANAGEMENT } from '../../../routes/routeConstants';

const DashboardOverview = () => {
  const navigate = useNavigate();
  const { dashboardStatsData } = useAppSelector((state) => state.dashboardData);
  const [showTopTierModal, setShowTopTierModal] = useState(false);

  return (
    <Container>
      <CardTitle>
        OVERVIEW{' '}
        <ButtonArea>
          <NavBtn
            onClick={() => {
              setShowTopTierModal(true);
            }}
          >
            Update performance tier
          </NavBtn>
          <NavBtn
            className='blue'
            onClick={() => {
              navigate(`/${REVENUE_PRICE_MANAGEMENT}`);
            }}
          >
            Manage Pricing
          </NavBtn>
        </ButtonArea>
      </CardTitle>
      <CardContainerWrapper>
        {/* Left */}
        {/* <LeftCardsContainer> */}
        {/* Card 1 */}
        <Card.Root padding='12px 24px' height='160px'>
          <Card.Header padding='12px'>
            <BallIcon /> Total No. of Drivers Hired
          </Card.Header>
          <Card.Body>
            <Card.LargeNumber type='default'>
              {dashboardStatsData?.hiredDrivers ?? 0}
            </Card.LargeNumber>
          </Card.Body>
          <Card.StatsArea trend='up' num={24.3}>
            <div>vs last week</div>
          </Card.StatsArea>
        </Card.Root>

        {/* Card 2 */}
        <Card.Root padding='12px 24px' height='160px'>
          <Card.Header padding='12px'>
            <ProfileListIcon /> Total No. of Listed Drivers
          </Card.Header>
          <Card.Body>
            <Card.LargeNumber type='default'>
              {dashboardStatsData?.listedDrivers ?? 0}
            </Card.LargeNumber>
          </Card.Body>
          {/* <Card.StatsArea trend='up' num={24.3}>
            <div>vs last week</div>
          </Card.StatsArea> */}
        </Card.Root>

        {/* Card 3 */}
        <Card.Root padding='12px 24px' height='160px'>
          <Card.Header padding='12px'>
            <CashIcon /> Amount of Revenue from Lookups
          </Card.Header>
          <Card.Body>
            <Card.LargeNumber type='currency'>
              {dashboardStatsData?.revenue ?? 0}
            </Card.LargeNumber>
          </Card.Body>
          <Card.StatsArea trend='down' num={-1.3} marginTop='30px'>
            <div>vs last week</div>
          </Card.StatsArea>
        </Card.Root>

        {/* Card 4 */}
        <Card.Root padding='12px 24px' height='160px'>
          <Card.Header padding='12px'>
            <StarIcon /> All-time Rating Count
          </Card.Header>
          <Card.Body>
            <Card.LargeNumber type='default'>
              {dashboardStatsData?.ratingCount ?? 0}
            </Card.LargeNumber>
          </Card.Body>
          {/* <Card.StatsArea trend='down' num={-1.3} marginTop='30px'>
            <div>vs last week</div>
          </Card.StatsArea> */}
        </Card.Root>

        {/* Card 5 */}
        <Card.Root padding='12px 24px' height='fit-content'>
          <Card.Header alignSelf='flex-start'>
            <LargeDotIcon /> KYC request
          </Card.Header>
          <Card.BodyText>
            You have no KYC requests waiting for your review at this time.
          </Card.BodyText>
          {/* <Card.FooterNav path={`/${KYC_COMPLIANCE}`}>
            View requests
          </Card.FooterNav> */}
        </Card.Root>
      </CardContainerWrapper>

      <Modal showModal={showTopTierModal} setShowModal={setShowTopTierModal}>
        <TopTierBenchmarkModal />
      </Modal>
    </Container>
  );
};

export default DashboardOverview;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`;

const CardContainerWrapper = styled.div`
  /* display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 20px; */
  width: 100%;

  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  width: 100%;
`;

const CardTitle = styled.div`
  font-weight: 700;
  color: ${({ theme }) => theme.palette.grayTextColor};
  font-size: 16px;
  line-height: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const ButtonArea = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const NavBtn = styled.div`
  font-size: 14px;
  color: ${({ theme }) => theme.palette.blueColor};
  border: 1px solid ${({ theme }) => theme.palette.blueColor};
  width: fit-content;
  padding: 12px 16px;
  border-radius: 8px;
  cursor: pointer;

  &.blue {
    /* background-color: ${({ theme }) => theme.palette.blueColor}; */
    color: white;
    background: linear-gradient(
      262.94deg,
      #436db8 9.61%,
      #5b91f5 49.28%,
      #3c80ff 85.91%
    );
  }
`;
